import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";

import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";

export const ApprovalInformationTable = observer(() => {
  const {
    productManagement: { productDetail },
  } = useStores();
  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <TableCell colSpan={3} align="center">
            Ký Duyệt Mẫu
          </TableCell>
          <TableCell colSpan={3} align="center">
            Ký Duyệt Màu Sắc In Ấn
          </TableCell>
          <TableCell rowSpan={2} align="center">
            Yêu cầu khách hàng
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Số Ký Duyệt</TableCell>
          <TableCell>Ngày Ký Duyệt Mẫu</TableCell>
          <TableCell>Hạn Dùng</TableCell>
          <TableCell>Số Ký Duyệt</TableCell>
          <TableCell>Ngày Ký Duyệt Mẫu</TableCell>
          <TableCell>Hạn Dùng</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{productDetail?.approval?.businessNumber || ""}</TableCell>
          <TableCell>
            {dateTimeDisplay(productDetail?.approval?.businessDate)}
          </TableCell>
          <TableCell>
            {dateTimeDisplay(productDetail?.approval?.businessExpiredDate)}
          </TableCell>
          <TableCell>{productDetail?.approval?.printNumber || ""}</TableCell>
          <TableCell>
            {dateTimeDisplay(productDetail?.approval?.printDate)}
          </TableCell>
          <TableCell>
            {dateTimeDisplay(productDetail?.approval?.printExpiredDate)}
          </TableCell>
          <TableCell>
            {productDetail?.approval?.customerRequest || ""}
          </TableCell>
        </TableRow>
      </TableBody>
    </XTablePagination>
  );
});
